module.exports = __webpack_public_path__ + "static/img/09.30768b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/09.jpg
// module id = 404
// module chunks = 1